module.exports = __webpack_public_path__ + "static/media/logo.f5c5f655.png";